import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";
import { DashboardIcon, ServersIcon, GeneratorIcon, LogsIcon, SettingsIcon } from "./icons";

const NAV_ITEMS = [
  { to: "/", label: "Dashboard", icon: DashboardIcon, end: true },
  { to: "/servers", label: "Servers", icon: ServersIcon, end: false },
  { to: "/generator", label: "Generator", icon: GeneratorIcon, end: false },
  { to: "/message-logs", label: "Message Logs", icon: LogsIcon, end: false },
  { to: "/settings", label: "Settings", icon: SettingsIcon, end: false },
];

export function Layout({ children }: { children: ReactNode }) {
  const { logout } = useAuth();

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark" />
          <span className="brand-name">Fleet Console</span>
        </div>

        <ul className="nav-list">
          {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
            <li key={to}>
              <NavLink to={to} end={end} className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}>
                <Icon />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="sidebar-footer">
          <button type="button" className="btn btn-ghost btn-sm" style={{ width: "100%" }} onClick={() => logout()}>
            Log out
          </button>
        </div>
      </aside>
      <main className="main">{children}</main>
    </div>
  );
}
